export default function Logo({ size = 44, className = "" }) {
  return (
    <img
      src="/assets/logo.jpg"
      alt="अंशा वेलफेयर सोसाइटी लोगो"
      width={size}
      height={size}
      className={`rounded-full object-cover ring-2 ring-ngo-deep/15 ${className}`}
    />
  );
}
